/* Diamond feed (2026-10-16): the lab-grown diamond search on /collections/diamonds, and each diamond's own page
   (/collections/diamonds?stone=ID: photo/360°, key specs, delivery estimate, Add to bag, report, similar diamonds, 4 C's).
   Talks to the search API (sections/mg-diamond-search.liquid, setting "Search API"):
   GET /api/meta, /api/search, /api/stone; POST /api/select returns the stone's Shopify variant,
   which goes into the bag through the theme's cart drawer (the same path as product forms).
   Filters live in the page URL (same names as the API), so a search can be shared or bookmarked. */
(() => {
  const root = document.querySelector('[data-mgd]');
  if (!root) return;

  const API = (root.dataset.api || '').replace(/\/+$/, '');
  const PER = parseInt(root.dataset.per, 10) || 24;
  const COLORS = ['D', 'E', 'F', 'G', 'H', 'I', 'J', 'K+'];
  const CLARITY = ['FL', 'IF', 'VVS1', 'VVS2', 'VS1', 'VS2', 'SI1', 'SI2', 'I1+'];
  const CLARITY_API = ['FL', 'IF', 'VVS1', 'VVS2', 'VS1', 'VS2', 'SI1', 'SI2', 'I3'];
  const KEYS = ['shape', 'price_min', 'price_max', 'carat_min', 'carat_max', 'color_min', 'color_max', 'clarity_min', 'clarity_max',
    'cut', 'lab', 'fluor', 'ratio_min', 'ratio_max', 'depth_min', 'depth_max', 'table_min', 'table_max', 'video', 'photo', 'sort', 'all'];
  // The page opens with the section's default filters (owner, 2026-10-16: 1 ct and up) unless the URL sets any filter other
  // than shape or sort; Reset writes all=1 so the full list stays shown on reload and back/forward.
  const DEFAULTS = new URLSearchParams(root.dataset.defaults || '');
  // photo=1 by default (only stones with a working photo); photo=0 in the URL shows every stone
  const CARAT = [0.3, 10];
  let PRICE = [40, 180000];

  const $ = (s, el = root) => el.querySelector(s);
  const $$ = (s, el = root) => Array.from(el.querySelectorAll(s));
  const money = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 0 });
  const count = new Intl.NumberFormat('en-US');
  const esc = (s) => String(s ?? '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

  // ---------- the noon-4 PM price (owner, 2026-10-16): every day noon-4 PM Chicago time, diamonds at the original markup ----------
  // The search API reports the window (`daytime`: active, from, to, next switch, its own clock) and each stone's dayPrice;
  // `price` stays the regular price. While the window is open the page shows the daytime price with a countdown, filters
  // by it, and asks for it in the bag (X-MG-Daytime; the API checks the clock itself). At the switch the prices reload.
  let DAY = null, skew = 0, switchTimer = null, onDaySwitch = null;
  const dayOn = () => !!(DAY && DAY.active && Date.now() + skew < Date.parse(DAY.next));
  const shown = (d) => (dayOn() && d.dayPrice ? d.dayPrice : d.price);
  const hourLabel = (h) => { const x = h % 24; return `${x % 12 || 12} ${x < 12 ? 'AM' : 'PM'}`; }; // 24 = midnight
  const left = () => {
    const t = Math.max(0, Math.floor((Date.parse(DAY.next) - (Date.now() + skew)) / 1000));
    return `${Math.floor(t / 3600)}:${String(Math.floor(t / 60) % 60).padStart(2, '0')}:${String(t % 60).padStart(2, '0')}`;
  };
  function setDay(w) {
    if (!w) return;
    DAY = w; skew = Date.parse(w.now) - Date.now();
    clearTimeout(switchTimer);
    const ms = Date.parse(w.next) - (Date.now() + skew);
    if (ms > 0 && ms < 2147483647) switchTimer = setTimeout(() => { if (onDaySwitch) onDaySwitch(); }, ms + 1500);
  }
  const parts = () => { const t = Math.max(0, Math.floor((Date.parse(DAY.next) - (Date.now() + skew)) / 1000)); return [Math.floor(t / 3600), Math.floor(t / 60) % 60, t % 60].map((n) => String(n).padStart(2, '0')); };
  setInterval(() => {
    if (!dayOn()) return;
    document.querySelectorAll('[data-day-clock]').forEach((e) => { e.textContent = left(); });
    const [h, m, sec] = parts();
    document.querySelectorAll('[data-timer]').forEach((e) => { e.querySelector('[data-h]').textContent = h; e.querySelector('[data-m]').textContent = m; e.querySelector('[data-s]').textContent = sec; });
  }, 1000);
  // the search toolbar's line
  function paintDayBar() {
    let el = root.querySelector('.mgd-bar__day');
    if (!DAY) { if (el) el.remove(); return; }
    if (!el) { el = document.createElement('p'); el.className = 'mgd-bar__day'; countEl.after(el); }
    if (!dayOn()) { el.remove(); return; } // owner, 2026-10-16: nothing about it outside noon-4 PM
    el.innerHTML = `Prices end in <b data-day-clock>${left()}</b>`;
  }

  const grid = $('[data-mgd-grid]');
  const status = $('[data-mgd-status]');
  const countEl = $('[data-mgd-count]');
  const loadBtn = $('[data-mgd-load]');
  const panel = $('[data-mgd-panel]');
  const glyphs = {};
  $$('[data-glyph]', $('[data-mgd-glyphs]').content).forEach((g) => { glyphs[g.dataset.glyph] = g.innerHTML; });

  // ---------- state <-> URL ----------
  let state = {};
  function readUrl() {
    const q = new URLSearchParams(location.search);
    state = {};
    for (const k of KEYS) if (q.get(k)) state[k] = q.get(k);
    if (!state.all && !KEYS.some((k) => k !== 'shape' && k !== 'sort' && state[k])) {
      for (const [k, v] of DEFAULTS) if (KEYS.includes(k) && v && !state[k]) state[k] = v;
    }
  }
  function writeUrl(push) {
    const q = new URLSearchParams(location.search);
    for (const k of KEYS) q.delete(k);
    for (const k of KEYS) if (state[k]) q.set(k, state[k]);
    const url = location.pathname + (q.toString() ? '?' + q.toString() : '');
    history[push ? 'pushState' : 'replaceState'](history.state, '', url);
    remember();
  }
  const filtered = () => KEYS.some((k) => k !== 'sort' && k !== 'photo' && k !== 'all' && state[k]) || state.photo === '0';
  const cleared = () => (state.sort ? { sort: state.sort, all: '1' } : { all: '1' });

  // ---------- range sliders (two native range inputs over one track) ----------
  const scales = {
    price: { to: (t) => Math.round(Math.exp(Math.log(PRICE[0]) + t * (Math.log(PRICE[1]) - Math.log(PRICE[0])))),
      from: (v) => (Math.log(v) - Math.log(PRICE[0])) / (Math.log(PRICE[1]) - Math.log(PRICE[0])), label: (v) => money.format(v) },
    carat: { to: (t) => Math.round((CARAT[0] + t * t * (CARAT[1] - CARAT[0])) * 100) / 100,
      from: (v) => Math.sqrt((v - CARAT[0]) / (CARAT[1] - CARAT[0])), label: (v) => v.toFixed(2) },
  };
  const ranges = {};
  function buildRange(el) {
    const kind = el.dataset.range;
    const steps = kind === 'color' ? COLORS : kind === 'clarity' ? CLARITY : null;
    const max = steps ? steps.length - 1 : 1000;
    el.innerHTML = `<div class="mgd-range__track"><span class="mgd-range__fill"></span></div>
      <input type="range" min="0" max="${max}" step="1" value="0" aria-label="${kind} from">
      <input type="range" min="0" max="${max}" step="1" value="${max}" aria-label="${kind} to">
      ${steps ? `<ol class="mgd-range__steps" aria-hidden="true">${steps.map((s) => `<li>${s}</li>`).join('')}</ol>` : ''}`;
    const [a, b] = el.querySelectorAll('input');
    const fill = el.querySelector('.mgd-range__fill');
    const r = { el, kind, steps, max, a, b, fill };
    const paint = () => {
      const lo = Math.min(+a.value, +b.value), hi = Math.max(+a.value, +b.value);
      fill.style.left = (lo / max) * 100 + '%';
      fill.style.right = 100 - (hi / max) * 100 + '%';
      if (steps) {
        el.querySelectorAll('.mgd-range__steps li').forEach((li, i) => li.classList.toggle('is-in', i >= lo && i <= hi));
        a.setAttribute('aria-valuetext', steps[lo]); b.setAttribute('aria-valuetext', steps[hi]);
      } else {
        const s = scales[kind];
        const lv = s.to(lo / max), hv = s.to(hi / max);
        a.setAttribute('aria-valuetext', s.label(lv)); b.setAttribute('aria-valuetext', s.label(hv));
        const inLo = $(`[data-in="${kind}_min"]`), inHi = $(`[data-in="${kind}_max"]`);
        if (document.activeElement !== inLo) inLo.value = lo === 0 ? '' : kind === 'price' ? count.format(lv) : lv.toFixed(2);
        if (document.activeElement !== inHi) inHi.value = hi === max ? '' : kind === 'price' ? count.format(hv) : hv.toFixed(2);
      }
    };
    const commit = () => {
      const lo = Math.min(+a.value, +b.value), hi = Math.max(+a.value, +b.value);
      if (steps) {
        const set = kind === 'color'
          ? [lo === 0 ? '' : COLORS[lo], hi === max ? '' : (COLORS[hi] === 'K+' ? 'Z' : COLORS[hi])]
          : [lo === 0 ? '' : CLARITY_API[lo], hi === max ? '' : CLARITY_API[hi]];
        state[kind + '_min'] = set[0]; state[kind + '_max'] = set[1];
      } else {
        const s = scales[kind];
        state[kind + '_min'] = lo === 0 ? '' : String(s.to(lo / max));
        state[kind + '_max'] = hi === max ? '' : String(s.to(hi / max));
      }
      changed();
    };
    for (const inp of [a, b]) {
      inp.addEventListener('input', paint);
      inp.addEventListener('change', commit);
    }
    r.paint = paint;
    r.load = () => {
      if (steps) {
        const list = kind === 'color' ? COLORS.map((c) => c[0]) : CLARITY_API;
        const lo = state[kind + '_min'] ? Math.max(0, list.indexOf(state[kind + '_min'])) : 0;
        let hi = max;
        const mx = state[kind + '_max'];
        if (mx) hi = kind === 'color' && mx > 'J' ? max : Math.max(0, list.indexOf(mx));
        if (hi < 0 || hi > max) hi = max;
        a.value = lo; b.value = hi;
      } else {
        const s = scales[kind];
        const clamp = (t) => Math.min(max, Math.max(0, Math.round(t * max)));
        a.value = state[kind + '_min'] ? clamp(s.from(+state[kind + '_min'])) : 0;
        b.value = state[kind + '_max'] ? clamp(s.from(+state[kind + '_max'])) : max;
      }
      paint();
    };
    ranges[kind] = r;
  }

  // ---------- controls ----------
  function loadControls() {
    const shapes = (state.shape || '').split(',').filter(Boolean);
    $$('.mgd-shape').forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.shape ? shapes.includes(b.dataset.shape) : !shapes.length)));
    Object.values(ranges).forEach((r) => r.load());
    $$('[data-chips]').forEach((g) => {
      const v = state[g.dataset.chips] || '';
      g.querySelectorAll('[role=radio]').forEach((c) => c.setAttribute('aria-checked', String(c.dataset.v === v)));
    });
    for (const k of ['ratio_min', 'ratio_max', 'depth_min', 'depth_max', 'table_min', 'table_max']) {
      const el = $(`[data-in="${k}"]`); if (el) el.value = state[k] || '';
    }
    $('[data-in="video"]').checked = state.video === '1';
    $('[data-in="photo"]').checked = state.photo !== '0';
    $('[data-in="sort"]').value = state.sort || 'price_asc';
    if (['fluor', 'lab', 'ratio_min', 'ratio_max', 'depth_min', 'depth_max', 'table_min', 'table_max', 'video'].some((k) => state[k]) || state.photo === '0') $('[data-mgd-more]').open = true;
    $$('[data-mgd-reset]').forEach((b) => { if (b.classList.contains('mgd-bar__reset')) b.hidden = !filtered(); });
  }

  $$('.mgd-shape').forEach((btn) => btn.addEventListener('click', () => {
    let shapes = (state.shape || '').split(',').filter(Boolean);
    const s = btn.dataset.shape;
    if (!s) shapes = [];
    else shapes = shapes.includes(s) ? shapes.filter((x) => x !== s) : [...shapes, s];
    if (shapes.length === 9) shapes = [];
    state.shape = shapes.join(',');
    loadControls(); changed();
  }));
  $$('[data-chips]').forEach((g) => g.addEventListener('click', (e) => {
    const c = e.target.closest('[role=radio]'); if (!c) return;
    state[g.dataset.chips] = c.dataset.v;
    loadControls(); changed();
  }));
  const parseNum = (v) => { const x = parseFloat(String(v).replace(/[^0-9.]/g, '')); return Number.isFinite(x) ? x : null; };
  $$('[data-in]').forEach((el) => {
    const k = el.dataset.in;
    if (k === 'sort') return el.addEventListener('change', () => { state.sort = el.value === 'price_asc' ? '' : el.value; changed(); });
    if (k === 'video') return el.addEventListener('change', () => { state.video = el.checked ? '1' : ''; changed(); });
    if (k === 'photo') return el.addEventListener('change', () => { state.photo = el.checked ? '' : '0'; changed(); });
    el.addEventListener('change', () => {
      const x = parseNum(el.value);
      state[k] = x === null ? '' : String(k.startsWith('price') ? Math.round(x) : x);
      loadControls(); changed();
    });
    el.addEventListener('keydown', (e) => { if (e.key === 'Enter') el.blur(); });
  });
  $$('[data-mgd-reset]').forEach((b) => b.addEventListener('click', () => {
    state = cleared();
    loadControls(); changed();
  }));

  // phones: the filters are a drawer (Esc closes it; focus goes in and comes back to the Filters button)
  const openBtn = $('[data-mgd-open-panel]');
  let pending = false; // a search finished while the drawer was open: jump to its results once it closes
  const closePanel = () => {
    if (!panel.classList.contains('is-open')) return;
    panel.classList.remove('is-open'); document.documentElement.classList.remove('mgd-lock'); openBtn.setAttribute('aria-expanded', 'false');
    if (pending) { pending = false; toResults(); }
    openBtn.focus({ preventScroll: true });
  };
  openBtn.addEventListener('click', () => {
    panel.classList.add('is-open'); document.documentElement.classList.add('mgd-lock'); openBtn.setAttribute('aria-expanded', 'true');
    const x = $('.mgd-panel__close'); if (x) setTimeout(() => x.focus({ preventScroll: true }), 50);
  });
  $$('[data-mgd-close-panel]').forEach((b) => b.addEventListener('click', closePanel));
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closePanel(); });
  // computers: "More filters" sits at the right of the filter labels, so opening it never moves it (review r1)
  const more = $('[data-mgd-more]'), moreBtn = $('[data-mgd-more-toggle]');
  if (more && moreBtn) {
    const sync = () => moreBtn.setAttribute('aria-expanded', String(more.open));
    moreBtn.addEventListener('click', () => { more.open = !more.open; });
    more.addEventListener('toggle', sync); sync();
  }

  // ---------- search ----------
  let page = 1, inflight = null, timer = null, total = 0, jump = false;
  // dia r8 (2026-10-25): stones fetched from the API but not shown yet (photographed ones only), so every load shows
  // PER of them and ends on a full row; apiPage = the last API page asked for
  let apiPage = 0, buf = [], apiEnd = false;
  const RESERVE = 6;
  function changed() {
    writeUrl(false);
    $$('.mgd-bar__reset').forEach((x) => { x.hidden = !filtered(); });
    jump = true;
    clearTimeout(timer);
    timer = setTimeout(() => search(false), 180);
  }
  // review r1: a new search while the shopper is down the list (sort in the sticky bar, the phone drawer) starts them
  // at the top of the new results instead of somewhere in the middle of them
  function toResults() {
    if (panel.classList.contains('is-open')) { pending = true; return; }
    const bar = $('.mgd-bar');
    const hdr = document.querySelector('.shopify-section-header-sticky');
    const above = (hdr ? hdr.offsetHeight : 0) + bar.offsetHeight + 16;
    if (grid.getBoundingClientRect().top < bar.getBoundingClientRect().bottom) {
      window.scrollTo({ top: Math.max(0, grid.getBoundingClientRect().top + scrollY - above), behavior: 'instant' });
    }
  }
  function apiParams(p) {
    const q = new URLSearchParams();
    for (const k of KEYS) if (state[k]) q.set(k, state[k]);
    if (state.photo === '0') q.delete('photo'); else q.set('photo', '1');
    if (dayOn()) q.set('price_basis', 'day'); // the price filter reads the prices on the page
    q.set('per', PER); q.set('page', p);
    return q;
  }
  // upto > 1: back from a diamond, so load every page the shopper had open (review r1)
  async function search(more, upto = 1) {
    if (!API) return showStatus('The diamond search is being set up. Please check back soon, or <a href="' + esc(root.dataset.appointment) + '">book an appointment</a>.');
    const go = jump && !more; jump = false;
    if (inflight) inflight.abort();
    inflight = new AbortController();
    const signal = inflight.signal;
    root.classList.add('is-loading');
    // dia r8 (2026-10-25, owner picked the Diamonds suggestions): each load shows PER photographed stones in price order,
    // so the grid ends on a full row (stones without a usable photo used to be hidden after the fact, leaving 23 of 24);
    // what the API sent beyond that waits in `buf` for "Show more". photo=0 (every stone) keeps them all, as before.
    if (!more) { apiPage = 0; buf = []; apiEnd = false; }
    const usable = (d) => state.photo === '0' || !noPhoto(d);
    try {
      const one = async (p) => {
        const url = `${API}/api/search?${apiParams(p)}`;
        const early = window.__mgdEarly; // dia r8: the section may have asked for page 1 already
        let r = null;
        if (p === 1 && early && early.search && early.searchUrl === url) { try { r = await early.search; } catch (e) { r = null; } early.search = null; }
        if (!r) r = await fetch(url, { signal });
        if (!r.ok) throw new Error(r.status);
        return r.json();
      };
      const take = (j) => { total = j.total; setDay(j.daytime); buf.push(...j.items.filter(usable)); };
      const want = more ? 1 : Math.max(1, upto);
      if (!more && want > 1) { // back from a diamond: every page the shopper had open (review r1)
        (await Promise.all(Array.from({ length: want }, (_, i) => one(i + 1)))).forEach(take);
        apiPage = want; if (want * PER >= total) apiEnd = true;
      }
      // a few more than shown (RESERVE), so a stone whose photo then fails can hand its place on (wireImages)
      while (buf.length < want * PER + RESERVE && !apiEnd) {
        const j = await one(apiPage + 1); apiPage += 1; take(j);
        if (apiPage * PER >= total || !j.items.length || apiPage >= 400) apiEnd = true;
      }
      if (signal.aborted) return;
      const items = buf.splice(0, want * PER);
      page = more ? page + 1 : want;
      countEl.textContent = `${count.format(total)} ${total === 1 ? 'diamond' : 'diamonds'}`;
      const label = $('[data-mgd-show]'); if (label) label.textContent = `Show ${count.format(total)} ${total === 1 ? 'diamond' : 'diamonds'}`;
      paintDayBar();
      const html = items.map((d, i) => cardHtml(d, more ? 99 : i)).join(''); // dia r8: the first row's photos first
      if (more) grid.insertAdjacentHTML('beforeend', html); else grid.innerHTML = html;
      wireImages(grid);
      if (go) toResults();
      loadBtn.hidden = (apiEnd && !buf.length) || page >= 400;
      if (!total) showStatus('No diamonds match these filters. <button type="button" class="mgd-link" data-mgd-reset-inline>Reset filters</button>');
      else status.hidden = true;
    } catch (e) {
      if (e.name === 'AbortError') return;
      grid.querySelectorAll('.mgd-grid__ph').forEach((x) => x.remove());
      showStatus('The diamond search didn’t load. Please try again in a moment.');
    } finally {
      root.classList.remove('is-loading');
    }
  }
  function showStatus(html) {
    status.innerHTML = html; status.hidden = false;
    if (!grid.children.length) loadBtn.hidden = true;
    const r = status.querySelector('[data-mgd-reset-inline]');
    if (r) r.addEventListener('click', () => { state = cleared(); loadControls(); changed(); });
  }
  loadBtn.addEventListener('click', () => search(true));

  const shapeKey = (s) => String(s || '').toLowerCase();
  function specs(d) {
    return [d.color, d.clarity, d.cut].filter(Boolean).join(' · ');
  }
  // fix r2 (2026-10-22): v360 "?m=t" links answer with a page, not a picture: those cards take their end-of-page place
  // (refine r3) from the first paint instead of jumping there when the photo fails
  const noPhoto = (d) => !d.img || /v360\.diamonds\/c\/[^?]*\?m=t/i.test(d.img);
  function cardHtml(d, i = 99) {
    const title = `${d.carat.toFixed(2)} ct ${d.shape}`;
    return `<li class="mgd-grid__item${noPhoto(d) ? ' is-nophoto' : ''}"><a class="mgd-card" href="${esc(root.dataset.searchUrl)}?stone=${encodeURIComponent(d.id)}" data-id="${esc(d.id)}">
      <span class="mgd-card__media" data-shape="${esc(shapeKey(d.shape))}">
        <span class="mgd-card__glyph">${glyphs[shapeKey(d.shape)] || ''}</span>
        ${d.img && !noPhoto(d) ? `<img ${i < (innerWidth < 750 ? 4 : 8) ? 'src' : 'data-defer'}="${esc(photoSrc(d.img, d.id))}" data-src0="${esc(d.img)}" data-id="${esc(d.id)}" alt="" ${i < (innerWidth < 750 ? 2 : 4) ? 'fetchpriority="high"' : 'loading="lazy"'} decoding="async" crossorigin="anonymous" referrerpolicy="no-referrer" width="600" height="600">` : ''}
      </span>
      <span class="mgd-card__title">${esc(title)}</span>
      <span class="mgd-card__specs">${esc(specs(d))}<span class="mgd-card__lab">${esc(d.lab)}</span></span>
      <span class="mgd-card__price">${money.format(shown(d))}</span>
    </a></li>`;
  }
  // supplier photos can take a few seconds: the shape's outline shows in the tile until the photo has arrived (review r1)
  // ---------- centring (owner, 2026-10-17: "the diamonds are not in the middle") ----------
  // Suppliers shoot each diamond sitting on a stand near the bottom of the frame, at very different sizes. The page
  // finds the diamond in the photo (a 96 px copy: pixels lighter than the stand that differ from the ground at the
  // ends of their row), then zooms and shifts the photo so the diamond sits in the middle of its square at about the
  // same size in every tile. Where the moved photo no longer reaches an edge, the tile takes the photo's own ground
  // colour and the photo's edges fade into it. The 360° video gets the same move (its first frame is the photo).
  // Reading pixels needs CORS: photo hosts that refuse it are read through the search API (/api/img).
  const boxes = new Map(), noCors = new Set();
  // measurements are kept in this browser (newest 1500) so a photo is read once, not on every visit
  let saved = {};
  try { saved = JSON.parse(localStorage.getItem('mgd:boxes') || '{}'); } catch (e) { /* private mode */ }
  const keep = (src, bx) => {
    saved[src] = bx ? [bx.l, bx.t, bx.r, bx.b, bx.a].map((v) => +v.toFixed(3)).concat(bx.g) : 0;
    const keys = Object.keys(saved); if (keys.length > 1500) keys.slice(0, keys.length - 1500).forEach((k) => delete saved[k]);
    try { localStorage.setItem('mgd:boxes', JSON.stringify(saved)); } catch (e) { /* full or private mode */ }
  };
  try { JSON.parse(sessionStorage.getItem('mgd:nocors') || '[]').forEach((h) => noCors.add(h)); } catch (e) { /* private mode */ }
  const hostOf = (u) => { try { return new URL(u).host; } catch (e) { return ''; } };
  // dia r8 (2026-10-25, owner picked the Diamonds suggestions): one download per photo. The photo on show is fetched with
  // CORS (crossorigin), so the centring reads its pixels from that same copy; hosts that refuse CORS show it through the
  // search API's relay (/api/img, cached a week), which allows it. The hosts seen refusing on 2026-10-25 are listed in the
  // section; others are learned on the way (sessionStorage, as before). A photo that fails is asked for once more through the relay.
  ((window.__mgdEarly && window.__mgdEarly.nocors) || []).forEach((h) => noCors.add(h)); // the list: sections/mg-diamond-search.liquid
  const relay = (id) => `${API}/api/img?id=${encodeURIComponent(id)}`;
  const photoSrc = (src, id) => (API && id && noCors.has(hostOf(src)) ? relay(id) : src);
  const saveNoCors = () => { try { sessionStorage.setItem('mgd:nocors', JSON.stringify([...noCors])); } catch (e) { /* private mode */ } };
  root.addEventListener('error', (e) => {
    const img = e.target;
    if (!API || !(img instanceof HTMLImageElement) || !img.dataset.id || img.dataset.relayed || img.src.startsWith(`${API}/api/img`)) return;
    img.dataset.relayed = '1';
    noCors.add(hostOf(img.dataset.src0 || img.src)); saveNoCors();
    e.stopImmediatePropagation(); // the photo's own error handling waits for the relay's answer
    img.src = relay(img.dataset.id);
  }, true);
  function readPixels(src) {
    return new Promise((ok, no) => {
      const im = new Image(); im.crossOrigin = 'anonymous'; im.referrerPolicy = 'no-referrer'; im.decoding = 'async';
      im.onload = () => ok(im); im.onerror = no; im.src = src;
    });
  }
  function findBox(im) {
    const N = 96, c = document.createElement('canvas'); c.width = c.height = N;
    const g = c.getContext('2d', { willReadFrequently: true }); g.drawImage(im, 0, 0, N, N);
    const px = g.getImageData(0, 0, N, N).data, at = (x, y) => (y * N + x) * 4;
    const diff = (i, j) => Math.abs(px[i] - px[j]) + Math.abs(px[i + 1] - px[j + 1]) + Math.abs(px[i + 2] - px[j + 2]);
    const ys = [], xs = [];
    for (let y = 0; y < N; y++) {
      const a = at(1, y), b = at(N - 2, y), hit = [];
      for (let x = 0; x < N; x++) {
        const i = at(x, y), lum = px[i] * 0.299 + px[i + 1] * 0.587 + px[i + 2] * 0.114;
        if (lum > 70 && Math.min(diff(i, a), diff(i, b)) > 40) hit.push(x);
      }
      if (hit.length >= 2) { ys.push(y); xs.push(...hit); }
    }
    if (ys.length < 6) return null;
    xs.sort((p, q) => p - q); // trim stray marks (supplier watermarks) at the sides
    const l = xs[Math.floor(xs.length * 0.01)], r = xs[Math.ceil(xs.length * 0.99) - 1];
    const ground = [0, 1, 2].map((ch) => { // the ground colour: the two top corners (the stand sits at the bottom)
      let sum = 0; for (let y = 0; y < 4; y++) for (let x = 0; x < 4; x++) sum += px[at(x, y) + ch] + px[at(N - 1 - x, y) + ch];
      return Math.round(sum / 32);
    });
    return { l: l / N, r: (r + 1) / N, t: ys[0] / N, b: (ys[ys.length - 1] + 1) / N, a: im.naturalWidth / im.naturalHeight, g: ground };
  }
  function measure(id, src, el) {
    if (!boxes.has(src) && src in saved) {
      const v = saved[src];
      boxes.set(src, Promise.resolve(v ? { l: v[0], t: v[1], r: v[2], b: v[3], a: v[4], g: v.slice(5, 8) } : null));
    }
    // dia r8: the photo on show came with CORS, so it is read in place (no second download)
    if (!boxes.has(src) && el && el.crossOrigin && el.complete && el.naturalWidth) {
      try { const bx = findBox(el); keep(src, bx); boxes.set(src, Promise.resolve(bx)); } catch (e) { /* not readable: the reads below */ }
    }
    if (!boxes.has(src)) {
      const host = hostOf(src), viaApi = () => (API && id ? readPixels(`${API}/api/img?id=${encodeURIComponent(id)}`) : Promise.reject());
      const first = noCors.has(host) ? viaApi() : readPixels(src).catch(() => {
        noCors.add(host); try { sessionStorage.setItem('mgd:nocors', JSON.stringify([...noCors])); } catch (e) { /* private mode */ }
        return viaApi();
      });
      boxes.set(src, first.then(findBox).then((bx) => { keep(src, bx); return bx; }, () => null)); // a failed read is tried again next visit
    }
    return boxes.get(src);
  }
  // the move for a square tile showing the photo with object-fit: cover
  function moveFor(bx) {
    let { l, r, t, b } = bx;
    if (bx.a > 1) { const o = (bx.a - 1) / 2; l = l * bx.a - o; r = r * bx.a - o; } // wide photo: sides cropped
    else if (bx.a < 1) { const o = (1 / bx.a - 1) / 2; t = t / bx.a - o; b = b / bx.a - o; }
    const cx = (l + r) / 2 - 0.5, cy = (t + b) / 2 - 0.5, size = Math.max(r - l, b - t);
    if (!(size > 0.08)) return null;
    // the diamond fills about 78% of the square; at most 1.5x (the photos are ~600-750 px), at least 0.72x
    const k = Math.max(0.72, Math.min(1.5, 0.78 / size)), x = -cx * k, y = -cy * k, lim = (k - 1) / 2;
    return { k, x, y, open: !(Math.abs(x) <= lim + 0.002 && Math.abs(y) <= lim + 0.002), g: bx.g };
  }
  function applyMove(el, mv) {
    el.style.setProperty('--mgd-k', mv.k.toFixed(3));
    el.style.setProperty('--mgd-x', `${(mv.x * 100).toFixed(2)}%`);
    el.style.setProperty('--mgd-y', `${(mv.y * 100).toFixed(2)}%`);
    el.classList.add('is-centred');
    el.classList.toggle('is-open', !!mv.open);
    if (mv.g && el.parentElement) el.parentElement.style.setProperty('--mgd-ground', `rgb(${mv.g.join(',')})`);
  }
  function centre(img) {
    if (img.closest('.mgd-p__duo.is-one')) return; // the wide lone tile shows the whole photo
    measure(img.dataset.id, img.dataset.src0 || img.getAttribute('src'), img).then((bx) => { const mv = bx && moveFor(bx); if (mv && img.isConnected) applyMove(img, mv); });
  }
  // the supplier 360° viewers that take the settings above show the same frame as the photo
  function centreVideo(stage, s) {
    const f = stage.querySelector('iframe');
    if (!f || !s.img || cleanVid(s.vid) === s.vid || hostOf(s.img) !== hostOf(s.vid)) return;
    measure(s.id, s.img).then((bx) => { const mv = bx && moveFor(bx); if (mv && f.isConnected) applyMove(f, mv); });
  }

  // speed r2 (2026-10-26): supplier photos are 250-350 KB each and phones show about four cards, so only the first
  // row(s) load at once (4 cards on phones, 8 on computers); the rest get their photo just before they scroll into view
  // (300 px ahead) instead of Chrome's ~2,500 px lazy-load reach. Until then the tile shows the shape's outline, as while
  // any photo loads.
  const deferIO = 'IntersectionObserver' in window ? new IntersectionObserver((ens) => ens.forEach((en) => {
    if (!en.isIntersecting) return; deferIO.unobserve(en.target); showDeferred(en.target);
  }), { rootMargin: '300px 0px' }) : null;
  function showDeferred(img) { const u = img.getAttribute('data-defer'); if (u) { img.removeAttribute('data-defer'); img.src = u; } }
  function wireImages(scope) {
    scope.querySelectorAll('.mgd-card__media img:not([data-wired]), .mgd-d__stage img:not([data-wired])').forEach((img) => {
      img.dataset.wired = '1';
      if (img.hasAttribute('data-defer')) { if (deferIO) deferIO.observe(img); else showDeferred(img); }
      const done = () => { if (img.parentElement) img.parentElement.classList.add('is-loaded'); centre(img); };
      if (img.complete && img.naturalWidth) done(); else img.addEventListener('load', done, { once: true });
      img.addEventListener('error', () => {
        const box = img.parentElement, shape = (img.closest('[data-shape]') || box).dataset.shape;
        img.remove();
        if (!box.querySelector('.mgd-card__glyph')) box.insertAdjacentHTML('afterbegin', `<span class="mgd-card__glyph">${glyphs[shape] || ''}</span>`);
        // refine r3 (2026-10-19): a search card with no photo (e.g. a v360.diamonds "?m=t" link answering "Ok") goes to the
        // end of its page (CSS order), so the first rows show real photos; the stone stays in the results
        // dia r8 (2026-10-25): it leaves the grid and the next stone in price order joins at the end, so the rows stay full
        const item = box.closest('[data-mgd-grid] .mgd-grid__item');
        if (item) {
          const next = buf.length ? buf.shift() : null;
          if (next) { item.remove(); grid.insertAdjacentHTML('beforeend', cardHtml(next)); wireImages(grid); loadBtn.hidden = (apiEnd && !buf.length) || page >= 400; return; }
          item.classList.add('is-nophoto');
        }
        // diamonds r5 (2026-10-23): a similar-diamond suggestion whose photo fails leaves the row, which re-centres;
        // r6 (owner: "so there are always three"): the next photographed stone of the same kind takes its place first
        const sim = box.closest('[data-similar-list] .mgd-grid__item');
        if (sim) {
          const list = sim.parentElement, st = list.__mgSim, label = sim.dataset.simLabel;
          const next = st && (st.pools[label] || []).find((x) => !st.used.has(x.id));
          if (next) {
            st.used.add(next.id);
            sim.insertAdjacentHTML('afterend', simCard(label, next, st.s));
            sim.remove();
            wireImages(list);
            return;
          }
          sim.remove();
          const n = list.children.length;
          list.classList.toggle('is-few', n < 3); list.style.setProperty('--mgd-n', n);
          if (!n) { const sec = list.closest('[data-similar]'); if (sec) sec.hidden = true; }
        }
      }, { once: true });
    });
  }

  // ---------- one diamond: its own page (/collections/diamonds?stone=ID) ----------
  // Owner, 2026-10-16: each diamond opens a full page (like Diyona's diamond-detail), not a pop-up.
  // The search keeps its last address in sessionStorage so "Back to diamond search" returns to the same filters.
  const pageEl = $('[data-mgd-page]');
  // ring r1 (2026-10-22): an appointment booked from a diamond's page arrives knowing the stone (?about=diamond +
  // sessionStorage mgAsk: the stone's grades only)
  let curStone = null;
  if (pageEl) pageEl.addEventListener('click', (e) => {
    const a = e.target && e.target.closest ? e.target.closest('a[href*="/pages/book-a-meeting"]') : null;
    if (!a || !curStone) return;
    const s = curStone;
    const ask = { kind: 'diamond', name: `${Number(s.ct).toFixed(2)} ct ${s.shape} Lab-Grown Diamond`, url: location.href, img: s.img && !/v360\.diamonds\/c\/[^?]*\?m=t/i.test(s.img) ? s.img : '',
      shape: s.shape || '', carat: `${Number(s.ct).toFixed(2)} ct`, stone: 'Lab-Grown Diamond',
      line: [s.color && `${s.color} Color`, s.clarity && `${s.clarity} Clarity`, s.cut && `${s.cut} Cut`, [s.lab, s.cert].filter(Boolean).join(' ')].filter(Boolean).join(' · ') };
    try { sessionStorage.setItem('mgAsk', JSON.stringify(ask)); } catch (err) { return; }
    const u = new URL(a.getAttribute('href'), location.href);
    u.searchParams.set('about', 'diamond');
    a.setAttribute('href', u.pathname + u.search + u.hash);
  }, true);
  const remember = () => { try { sessionStorage.setItem('mgd:last', location.pathname + location.search); } catch (e) { /* private mode */ } };
  const lastSearch = () => { try { return sessionStorage.getItem('mgd:last') || root.dataset.searchUrl; } catch (e) { return root.dataset.searchUrl; } };
  const fmt = (x, d = 2) => (x === null || x === undefined || x === '' ? '' : Number(x).toFixed(d));
  const COLOR_SCALE = ['D', 'E', 'F', 'G', 'H', 'I', 'J', 'K'];
  const CLARITY_SCALE = ['FL', 'IF', 'VVS1', 'VVS2', 'VS1', 'VS2', 'SI1', 'SI2'];
  const COLOR_WORDS = (c) => (c <= 'F' ? 'Colorless. No color is visible, even to a trained eye.' : c <= 'J'
    ? 'Near colorless. Any warmth is very hard to see once the diamond is set.' : 'Faint color. A soft warmth can be seen, most of all in white metals.');
  const CLARITY_WORDS = (c) => ({ FL: 'Flawless. No inclusions or blemishes under 10x magnification.',
    IF: 'Internally flawless. No inclusions under 10x magnification.',
    VVS1: 'Very, very slightly included. Inclusions are hard to find even under 10x magnification.',
    VVS2: 'Very, very slightly included. Inclusions are hard to find even under 10x magnification.',
    VS1: 'Very slightly included. Minor inclusions seen only under magnification.',
    VS2: 'Very slightly included. Minor inclusions seen only under magnification.',
    SI1: 'Slightly included. Inclusions show under magnification and sometimes to the eye.',
    SI2: 'Slightly included. Inclusions show under magnification and sometimes to the eye.' }[c] || 'Included. Inclusions can be visible to the eye.');
  function deliveryRange() {
    const lo = parseInt(root.dataset.dmin, 10) || 14, hi = parseInt(root.dataset.dmax, 10) || 21;
    const d = (n) => { const x = new Date(); x.setDate(x.getDate() + n); return x.toLocaleDateString('en-US', { month: 'short', day: 'numeric' }); };
    return `${d(lo)} – ${d(hi)}`;
  }
  const scale = (steps, at, label) => `<div class="mgd-scale" role="img" aria-label="${esc(label)}">
      <ol>${steps.map((s) => `<li${s === at ? ' class="is-at"' : ''}><span>${s}</span></li>`).join('')}</ol></div>`;

  // ---------- the gallery: photo, 360°, grading report, dimensions, proportions (owner, 2026-10-16) ----------
  const digits = (x) => String(x || '').replace(/\D/g, '');
  // IGI publishes every report as a PDF at pdf.igi.org/FDR<number>.pdf that can be shown inside the page
  const igiPdf = (s) => (s.lab === 'IGI' && digits(s.cert) ? `https://pdf.igi.org/FDR${digits(s.cert)}.pdf` : '');
  const reportUrl = (s) => igiPdf(s) || s.certLink;
  // The certificate is drawn with Mozilla's PDF.js (loaded only when Report is opened): phones don't show a PDF inside a
  // page. The PDF comes through the search API (/api/cert), which allows mineandgrown.com to read it.
  const PDFJS = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/4.10.38';
  let pdfjsLib = null;
  // the report card (GIA stones, and IGI stones whose PDF isn't published yet): lab, number, grades; a link only when
  // there is a report page to open
  const certCard = (s, link) => `<div class="mgd-p__cert-card"><p class="mgd-p__cert-lab">${esc(s.lab)}</p><p>Grading report ${esc(s.cert)}</p>`
    + `<p class="mgd-p__cert-grades">${esc([`${fmt(s.ct)} ct`, s.shape, s.color && `${s.color} Color`, s.clarity && `${s.clarity} Clarity`, s.cut && `${s.cut} Cut`].filter(Boolean).join(' · '))}</p>`
    + (link ? `<a class="button button--secondary" href="${esc(s.certLink)}" target="_blank" rel="noopener"><span class="button__label">View the report on ${s.lab === 'GIA' ? 'gia.edu' : 'igi.org'}</span></a>` : '') + '</div>';
  async function drawReport(stage, s) {
    const box = stage.querySelector('[data-cert]');
    if (!box) return;
    let libOk = false;
    try {
      if (!pdfjsLib) {
        pdfjsLib = await import(`${PDFJS}/pdf.min.mjs`);
        pdfjsLib.GlobalWorkerOptions.workerSrc = `${PDFJS}/pdf.worker.min.mjs`;
      }
      libOk = true;
      const doc = await pdfjsLib.getDocument({ url: `${API}/api/cert?id=${encodeURIComponent(s.id)}` }).promise;
      const page = await doc.getPage(1);
      if (!box.isConnected) return; // the shopper moved to another view
      const base = page.getViewport({ scale: 1 });
      const scale = (box.clientWidth / base.width) * Math.min(3, Math.max(2, window.devicePixelRatio || 1));
      const vp = page.getViewport({ scale });
      const canvas = box.querySelector('canvas');
      canvas.width = Math.round(vp.width); canvas.height = Math.round(vp.height);
      await page.render({ canvasContext: canvas.getContext('2d'), viewport: vp }).promise;
      box.classList.add('is-ready');
    } catch (e) {
      if (!box.isConnected) return;
      // fix r2 (2026-10-22): PDF.js loaded but the report didn't (the lab hasn't published the PDF yet): the report
      // card, not the storage host's error page; the gallery's open link and the View report row stop pointing at it
      if (libOk) {
        const open = box.nextElementSibling;
        if (open && open.classList.contains('mgd-d__open')) open.remove();
        box.outerHTML = certCard(s, false);
        document.querySelectorAll('.mgd-p__report').forEach((a) => { a.removeAttribute('href'); a.removeAttribute('target'); a.classList.add('is-pending'); });
        return;
      }
      // older browsers: the browser's own PDF viewer, as before
      box.outerHTML = `<iframe src="${esc(igiPdf(s))}#toolbar=0&navpanes=0&view=FitH" title="${esc(s.lab)} grading report ${esc(s.cert)}" loading="lazy"></iframe>`;
    }
  }
  const PROFILE = '<path d="M260 100h200l120 60v10L360 340 140 170v-10z"/><path d="M140 160h440M140 170h440M260 100l-50 60M460 100l50 60M300 100l-20 60M420 100l20 60M200 170l160 170M520 170L360 340M280 170l80 170M440 170l-80 170"/>';
  function views(s) {
    const v = [];
    if (s.img) v.push({ key: 'photo', label: 'Photo', art: `<img src="${esc(photoSrc(s.img, s.id))}" data-src0="${esc(s.img)}" data-id="${esc(s.id)}" alt="" crossorigin="anonymous" referrerpolicy="no-referrer" loading="lazy">` });
    if (s.vid) v.push({ key: 'video', label: '360°', art: '<svg viewBox="0 0 40 40" aria-hidden="true"><circle cx="20" cy="20" r="13" fill="none" stroke="currentColor" stroke-width="1.4"/><path d="M17 14.5l8 5.5-8 5.5z" fill="currentColor"/></svg>' });
    if (s.cert) v.push({ key: 'report', label: 'Report', art: `<svg viewBox="0 0 40 40" aria-hidden="true"><path d="M11 6h13l6 6v22H11z M24 6v6h6 M15 19h11M15 23h11M15 27h7" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linejoin="round"/></svg>` });
    if (s.L && s.W) v.push({ key: 'dimensions', label: 'Dimensions', art: glyphs[shapeKey(s.shape)] || '' });
    if (s.depth || s.table) v.push({ key: 'proportions', label: 'Proportions', art: `<svg viewBox="120 80 480 280" aria-hidden="true"><g fill="none" stroke="currentColor" stroke-width="8" stroke-linejoin="round">${PROFILE}</g></svg>` });
    return v;
  }
  // Owner, 2026-10-17: the suppliers' "Vision360" viewer drew two button rows, a zoom bar and a rounded frame, so the
  // diamond sat small inside the 360° tile. Its own settings (btn, sv, zoomslide, isBorderRadius) turn those off; the
  // "open in a new tab" link keeps the full viewer. Other viewers are left as they are.
  function cleanVid(u) {
    try {
      const x = new URL(u);
      if (!/\/vision360\.html$/i.test(x.pathname)) return u;
      for (const k of ['btn', 'sv', 'zoomslide', 'isBorderRadius']) x.searchParams.set(k, '0');
      return x.href;
    } catch (e) { return u; }
  }
  function viewHtml(s, key, tile) {
    const title = `${fmt(s.ct)} ct ${s.shape}`;
    if (key === 'photo') return `<span class="mgd-card__glyph">${glyphs[shapeKey(s.shape)] || ''}</span><img src="${esc(photoSrc(s.img, s.id))}" data-src0="${esc(s.img)}" data-id="${esc(s.id)}" alt="${esc(title)} lab-grown diamond" fetchpriority="high" crossorigin="anonymous" referrerpolicy="no-referrer">`;
    if (key === 'video') {
      return /\.mp4($|\?)/i.test(s.vid) ? `<video src="${esc(s.vid)}" autoplay muted loop playsinline controls></video>`
        : `<iframe src="${esc(cleanVid(s.vid))}" title="360° video of this diamond" loading="lazy" allow="fullscreen; autoplay" referrerpolicy="no-referrer"></iframe>
           <a class="mgd-d__open mgd-d__open--top" href="${esc(s.vid)}" target="_blank" rel="noopener">Open the video in a new tab</a>`;
    }
    if (key === 'report') {
      const pdf = igiPdf(s);
      return pdf
        ? `<a class="mgd-p__cert" data-cert href="${esc(pdf)}" target="_blank" rel="noopener" aria-label="${esc(s.lab)} grading report ${esc(s.cert)}, opens the full report">
             <canvas role="img" aria-label="${esc(s.lab)} grading report ${esc(s.cert)}"></canvas><span class="mgd-p__cert-wait">Loading the report…</span></a>
           <a class="mgd-d__open" href="${esc(pdf)}" target="_blank" rel="noopener">Open the full report</a>`
        : certCard(s, true);
    }
    if (key === 'dimensions') {
      const L = Math.max(s.L, s.W), W = Math.min(s.L, s.W);
      const g = (glyphs[shapeKey(s.shape)] || '').replace('<svg ', '<svg x="200" y="95" width="320" height="373" ');
      return `<svg class="mgd-dim" viewBox="0 0 720 620" role="img" aria-label="Length ${fmt(L)} mm, width ${fmt(W)} mm${s.H ? `, depth ${fmt(s.H)} mm` : ''}">
          <g class="mgd-dim__shape">${g}</g><g class="mgd-dim__marks" data-marks data-l="${fmt(L)}" data-w="${fmt(W)}"></g></svg>
        ${s.H ? `<p class="mgd-p__caption">Depth ${esc(fmt(s.H))} mm</p>` : ''}`;
    }
    if (key === 'proportions') {
      const t = (x, y, a, txt) => `<text x="${x}" y="${y}" text-anchor="${a}">${esc(txt)}</text>`;
      const lines = [];
      if (s.table) lines.push(`<path d="M260 62v-14M460 62v-14M260 55h200"/>`, t(360, 36, 'middle', `Table ${fmt(s.table, 1)}%`));
      if (s.depth) lines.push(`<path d="M612 100h14M612 340h14M619 100v240"/>`, t(636, 214, 'start', 'Depth'), t(636, 238, 'start', `${fmt(s.depth, 1)}%`));
      const crown = [s.crownA && `${fmt(s.crownA, 1)}°`, s.crownH && `${fmt(s.crownH, 1)}%`].filter(Boolean).join(' · ');
      const pav = [s.pavA && `${fmt(s.pavA, 1)}°`, s.pavD && `${fmt(s.pavD, 1)}%`].filter(Boolean).join(' · ');
      const stack = (y, label, parts) => [label, ...parts].map((x, i) => t(122, y + i * 28, 'end', x));
      const crownP = [s.crownA && `${fmt(s.crownA, 1)}°`, s.crownH && `${fmt(s.crownH, 1)}%`].filter(Boolean);
      const pavP = [s.pavA && `${fmt(s.pavA, 1)}°`, s.pavD && `${fmt(s.pavD, 1)}%`].filter(Boolean);
      if (crown) lines.push(...(tile ? stack(112, 'Crown', crownP) : [t(122, 124, 'end', 'Crown'), t(122, 148, 'end', crown)]));
      if (pav) lines.push(...(tile ? stack(226, 'Pavilion', pavP) : [t(122, 238, 'end', 'Pavilion'), t(122, 262, 'end', pav)]));
      const foot = [s.girdle && `Girdle ${s.girdle}`, s.culet && `Culet ${s.culet}`].filter(Boolean).join(' · ');
      return `<svg class="mgd-prop" viewBox="0 0 720 400" role="img" aria-label="Proportions: ${esc([s.table && `table ${fmt(s.table, 1)}%`, s.depth && `depth ${fmt(s.depth, 1)}%`, crown && `crown ${crown}`, pav && `pavilion ${pav}`].filter(Boolean).join(', '))}">
          <g class="mgd-prop__stone">${PROFILE}</g><g class="mgd-prop__marks">${lines.join('')}</g></svg>
        ${foot ? `<p class="mgd-p__caption">${esc(foot)}</p>` : ''}`;
    }
    return '';
  }
  // dimension lines hug the drawn outline: measure it once it is on the page
  function placeDimensions(stage, s) {
    const outer = stage.querySelector('.mgd-dim'), inner = outer && outer.querySelector('.mgd-dim__shape svg'), marks = outer && outer.querySelector('[data-marks]');
    if (!inner || !marks) return;
    let bb; try { bb = inner.getBBox(); } catch (e) { return; }
    const k = 320 / 120, y0 = 95 + bb.y * k, y1 = y0 + bb.height * k;
    // stretch the outline sideways to this stone's own width-to-length ratio (the drawing is a generic shape)
    const L = parseFloat(marks.dataset.l), W = parseFloat(marks.dataset.w);
    let sx = L && W ? (W / L) / (bb.width / bb.height) : 1;
    sx = Math.min(1.6, Math.max(0.6, sx));
    const cx = 200 + (bb.x + bb.width / 2) * k;
    inner.setAttribute('preserveAspectRatio', 'none');
    inner.setAttribute('width', 320 * sx);
    inner.setAttribute('x', cx - (bb.x + bb.width / 2) * k * sx);
    const x0 = cx - (bb.width * k * sx) / 2, x1 = cx + (bb.width * k * sx) / 2;
    const lx = x0 - 46, wy = y1 + 46;
    marks.innerHTML = `<path d="M${lx - 8} ${y0}h16M${lx - 8} ${y1}h16M${lx} ${y0}V${y1}M${x0} ${wy - 8}v16M${x1} ${wy - 8}v16M${x0} ${wy}H${x1}"/>
      <text x="${lx - 18}" y="${(y0 + y1) / 2 - 8}" text-anchor="end">Length</text><text x="${lx - 18}" y="${(y0 + y1) / 2 + 18}" text-anchor="end">${esc(marks.dataset.l)} mm</text>
      <text x="${(x0 + x1) / 2}" y="${wy + 40}" text-anchor="middle">Width ${esc(marks.dataset.w)} mm</text>`;
  }

  async function showStone(id) {
    root.classList.add('is-detail');
    document.documentElement.classList.add('mgd-detail-mode');
    const back = lastSearch();
    const robots = document.createElement('meta'); robots.name = 'robots'; robots.content = 'noindex'; document.head.appendChild(robots);
    // review r6: the loading view has the page's own shape (breadcrumb line; computers two squares, phones one square and
    // the thumbnail row), so nothing jumps when the diamond arrives
    pageEl.innerHTML = `<div class="mgd-p container" aria-busy="true"><div class="breadcrumb mg-hero-crumbs mgd-p__crumbs mgd-p__skel-crumbs" aria-hidden="true"><i></i></div>
      <div class="mgd-p__main mgd-p__skeleton"><div class="mgd-p__media"><div class="mgd-p__skel-duo"><span class="mgd-d__stage"></span><span class="mgd-d__stage"></span></div>
      <div class="mgd-p__skel-thumbs"><span></span><span></span><span></span><span></span><span></span></div></div>
      <div class="mgd-p__info"><i></i><i></i><i></i><i></i></div></div></div>`;
    if (!API) { pageEl.innerHTML = `<p class="mgd-status">The diamond search is being set up.</p>`; return; }
    let s;
    try {
      const early = window.__mgdEarly; // dia r8: the section asked for it as the page arrived
      let r = null;
      if (early && early.stone && early.stoneId === id) { try { r = await early.stone; } catch (e) { r = null; } early.stone = null; }
      if (!r) r = await fetch(`${API}/api/stone?id=${encodeURIComponent(id)}`);
      if (r.status === 404) throw new Error('gone');
      if (!r.ok) throw new Error(r.status);
      const j = await r.json();
      s = j.stone; setDay(j.daytime); curStone = s;
    } catch (e) {
      const gone = e.message === 'gone';
      pageEl.innerHTML = `<div class="mgd-p mgd-p--gone container">
        <h1 class="mgd-p__title">${gone ? 'This diamond is no longer available' : 'This diamond didn’t load'}</h1>
        <p class="mgd-p__gone-text">${gone ? 'Our list is refreshed every few hours, and diamonds can sell quickly.' : 'Please try again in a moment.'}</p>
        <div class="mgd-p__gone-actions">
          <a class="button button--primary" href="${esc(back)}" data-mgd-back><span class="button__label">Back to diamond search</span></a>
          <a class="button button--secondary" href="${esc(root.dataset.appointment)}"><span class="button__label">Book an appointment</span></a>
        </div></div>`;
      return;
    }
    const shape = s.shape, title = `${fmt(s.ct)} ct ${shape}`;
    // diam r4 (2026-10-22): rings of this shape for "Set it in a ring" (sections/mg-diamond-search.liquid templates)
    const setTpl = root.querySelector(`template[data-mgd-settings="${shapeKey(shape)}"]`);
    document.title = `${title} Lab-Grown Diamond, ${s.color} ${s.clarity} – Mine & Grown`;
    // refine r3 (after Ritani / Blue Nile): the grades in one quiet line under the title, as the cards write them
    const sub = [s.color && `${s.color} Color`, s.clarity && `${s.clarity} Clarity`, s.cut && `${s.cut} Cut`, s.lab].filter(Boolean).join(' · ');
    const rows = [
      ['Shape', shape], ['Carat', fmt(s.ct)], ['Color', s.color], ['Clarity', s.clarity], ['Cut', s.cut],
      ['Polish', s.pol], ['Symmetry', s.sym], ['Fluorescence', s.fl],
      ['Measurements', s.L ? `${fmt(s.L)} × ${fmt(s.W)} × ${fmt(s.H)} mm` : ''], ['Length to width', fmt(s.ratio)],
      ['Depth', s.depth ? fmt(s.depth, 1) + '%' : ''], ['Table', s.table ? fmt(s.table, 1) + '%' : ''],
      ['Girdle', s.girdle], ['Culet', s.culet], ['Grading lab', s.lab],
    ].filter(([, v]) => v);
    pageEl.innerHTML = `
      <div class="mgd-p container">
        <nav class="breadcrumb mg-hero-crumbs mgd-p__crumbs" aria-label="breadcrumbs">
          <a href="${esc(root.dataset.root || '/')}">Home</a><span class="mgd-p__sep" aria-hidden="true">›</span>
          <a href="${esc(back)}" data-mgd-back>Diamonds</a><span class="mgd-p__sep" aria-hidden="true">›</span><span aria-current="page">${esc(title)}</span>
        </nav>
        <div class="mgd-p__main">
          <div class="mgd-p__media" data-shape="${esc(shapeKey(shape))}">
            <div class="mgd-p__frame" data-frame>
              <div class="mgd-d__stage" data-stage></div>
              ${s.vid && s.img ? '<button type="button" class="mgd-p__pill" data-pill>360°</button>' : ''}
            </div>
            <div class="mgd-p__thumbs" role="group" aria-label="Views of this diamond">
              ${views(s).map((v) => `<button type="button" class="mgd-p__thumb" data-view="${v.key}" aria-pressed="false">
                <span class="mgd-p__thumb-art">${v.art}</span><span class="mgd-p__thumb-label">${v.label}</span></button>`).join('')}
            </div>
            <div class="mgd-p__tiles" data-tiles></div>
          </div>
          <div class="mgd-p__info">
            <h1 class="mgd-p__title">${esc(title)} Lab-Grown Diamond</h1>
            <p class="mgd-p__sub">${esc(sub)}</p>
            <div class="mgd-p__pricerow"><p class="mgd-p__price">${money.format(shown(s))}</p><span class="mgd-p__one">Only one available</span><div class="mgd-p__timer" data-day hidden></div></div>
            <p class="mgd-p__pay"><a href="/pages/financing">Pay over time</a> with Shop Pay Installments or Affirm</p>
            <button type="button" class="button button--primary mgd-d__add" data-add><span class="button__label">Add to bag</span></button>
            <p class="mgd-d__msg" data-msg role="status"></p>
            ${setTpl
              ? '<a class="mgd-p__ring-link" href="#MgdSettings" data-mgd-to-settings>Set it in a ring</a>'
              : `<a class="mgd-p__ring-link" href="${esc(root.dataset.appointment)}">Set it in a ring: book an appointment</a>`}
            <p class="mgd-p__delivery">Estimated delivery <strong>${deliveryRange()}</strong><span class="mgd-p__dot" aria-hidden="true">·</span>Free US shipping</p>
            ${root.dataset.returns ? `<p class="mgd-d__returns">${esc(root.dataset.returns)}</p>` : ''}
            <a class="mgd-p__report" href="${esc(reportUrl(s))}" target="_blank" rel="noopener">
              <span class="mgd-p__report-lab">${esc(s.lab)}</span>
              <span class="mgd-p__report-text">Grading report ${esc(s.cert)}</span>
              <span class="mgd-p__report-go">View report</span>
            </a>
            <details class="mgd-p__specs">
              <summary>Specifications</summary>
              <dl class="mgd-d__specs">${rows.map(([k, v]) => `<div><dt>${esc(k)}</dt><dd>${esc(v)}</dd></div>`).join('')}</dl>
            </details>
            <p class="mgd-p__help"><span class="mgd-p__help-label">Need help?</span><a href="mailto:info@mineandgrown.com">info@mineandgrown.com</a><a href="tel:+13057037001">+1 305-703-7001</a></p>
          </div>
        </div>
        <section class="mgd-p__similar" data-similar hidden>
          <h2 class="mgd-p__h2">Similar diamonds</h2>
          <ul class="mgd-grid mgd-grid--three" role="list" data-similar-list></ul>
        </section>
        <section class="mgd-p__cs">
          <h2 class="mgd-p__h2">This diamond’s 4 C’s</h2>
          <div class="mgd-p__cs-grid">
            <div><h3 class="mgd-p__h3">Color: ${esc(s.color)}</h3>${scale(COLOR_SCALE, s.color, `Color ${s.color} on the D to K scale`)}<p>${esc(COLOR_WORDS(s.color))}</p></div>
            <div><h3 class="mgd-p__h3">Clarity: ${esc(s.clarity)}</h3>${scale(CLARITY_SCALE, s.clarity, `Clarity ${s.clarity} on the FL to SI2 scale`)}<p>${esc(CLARITY_WORDS(s.clarity))}</p></div>
            <div><h3 class="mgd-p__h3">Carat: ${esc(fmt(s.ct))}</h3><p>${s.L ? `${esc(fmt(s.L))} × ${esc(fmt(s.W))} mm face up. ` : ''}Carat is weight, not size: cut and shape decide how large a diamond looks.</p></div>
            <div><h3 class="mgd-p__h3">Cut${s.cut ? `: ${esc(s.cut)}` : ''}</h3><p>${s.cut ? 'Cut grade measures how well the diamond returns light.' : `Labs grade cut on round diamonds. For this ${esc(shape.toLowerCase())}, polish (${esc(s.pol || '—')}) and symmetry (${esc(s.sym || '—')}) show the quality of the cut.`}</p></div>
          </div>
          <a class="mgd-d__link" href="${esc(root.dataset.guide)}">Read our guide to the 4 C’s</a>
        </section>
        ${setTpl ? `<section class="mgd-p__settings" id="MgdSettings" aria-labelledby="MgdSettingsTitle">
          <h2 class="mgd-p__h2" id="MgdSettingsTitle">Settings for your ${esc(shape.toLowerCase())}</h2>
          <div class="mgd-p__settings-grid" data-settings></div>
          <a class="mgd-d__link mgd-p__settings-link" href="${esc(root.dataset.appointment)}">Book a video or phone appointment to set this diamond</a>
        </section>` : ''}
      </div>
      <div class="mgd-p__sticky" data-sticky aria-hidden="true">
        <span class="mgd-p__sticky-text"><span class="mgd-p__sticky-name">${esc(title)}<span class="mgd-p__sticky-more"> Lab-Grown Diamond</span></span><strong><span class="mgd-p__sticky-grades">${esc([s.color, s.clarity].filter(Boolean).join(' · '))} · </span><span data-sticky-price>${money.format(shown(s))}</span></strong></span>
        <button type="button" class="button button--primary" data-sticky-add tabindex="-1"><span class="button__label">Add to bag</span></button>
      </div>`;
    if (setTpl) {
      pageEl.querySelector('[data-settings]').append(setTpl.content.cloneNode(true));
      const to = pageEl.querySelector('[data-mgd-to-settings]');
      // scroll without a #hash, which the page's own URL state would read as a navigation
      if (to) to.addEventListener('click', (e) => {
        e.preventDefault();
        const t = pageEl.querySelector('#MgdSettings');
        if (t) t.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
      });
    }
    wireImages(pageEl);
    wireStone(s);
    paintStone(s);
    similar(s);
    // at 8 AM / 4 PM Chicago: this diamond's price for the new window
    onDaySwitch = async () => {
      try {
        const j = await (await fetch(`${API}/api/stone?id=${encodeURIComponent(s.id)}`)).json();
        if (j.stone) { s.price = j.stone.price; s.dayPrice = j.stone.dayPrice; }
        setDay(j.daytime);
      } catch (e) { /* the next page load shows it */ }
      paintStone(s); similar(s);
    };
  }

  // the price, the daytime line under it and the bottom bar's price
  function paintStone(s) {
    const price = pageEl.querySelector('.mgd-p__price'), line = pageEl.querySelector('[data-day]');
    if (!price || !line) return;
    price.textContent = money.format(shown(s));
    pageEl.querySelectorAll('[data-sticky-price]').forEach((e) => { e.textContent = money.format(shown(s)); });
    // owner, 2026-10-16 ("run a timer like how William & Sons runs"; no "daytime" wording): from noon to 4 PM a timer
    // to the real 4 PM price change; outside those hours nothing but the regular price
    if (!dayOn() || !s.dayPrice || s.dayPrice >= s.price) { line.hidden = true; line.innerHTML = ''; return; }
    const [h, m, sec] = parts(), end = hourLabel(DAY.to);
    const unit = (n, key, label) => `<span class="mgd-p__timer-unit"><span class="mgd-p__timer-num" ${key}>${n}</span><span class="mgd-p__timer-lab">${label}</span></span>`;
    line.hidden = false;
    line.innerHTML = `<p class="mgd-p__timer-head">This price ends in</p>
      <div class="mgd-p__timer-body" data-timer role="timer" aria-label="This price ends at ${end} Central Time">
        ${unit(h, 'data-h', 'HRS')}<span class="mgd-p__timer-colon" aria-hidden="true">:</span>${unit(m, 'data-m', 'MIN')}<span class="mgd-p__timer-colon" aria-hidden="true">:</span>${unit(sec, 'data-s', 'SEC')}
        <p class="mgd-p__timer-then">Ends at ${end} CT<br>${money.format(s.price)} after</p>
      </div>`;
  }

  // one similar-diamond card: its kind above the name, the difference in price after the price
  function simCard(label, d, s) {
    const diff = shown(d) - shown(s);
    return cardHtml(d).replace('<li class="mgd-grid__item', `<li data-sim-label="${esc(label)}" class="mgd-grid__item`)
      .replace('<span class="mgd-card__title">', `<span class="mgd-card__tag">${esc(label)}</span><span class="mgd-card__title">`)
      .replace(/(<span class="mgd-card__price">)([^<]*)(<\/span>)/, (m, open, price, close) => `${open}${price} <span class="mgd-card__diff">(${diff >= 0 ? '+' : '−'}${money.format(Math.abs(diff))})</span>${close}`);
  }

  async function similar(s) {
    const ci = 'DEFGHIJKLMNOPQRSTUVWXYZ'.indexOf(s.color), li = CLARITY_API.indexOf(s.clarity);
    // diamonds r6 (2026-10-23): eight candidates per kind, so a suggestion whose photo fails can be replaced
    const base = { shape: shapeKey(s.shape), photo: '1', per: '8' };
    const ct = Number(s.ct);
    const asks = [];
    if (ci > 0) asks.push(['Better color', { ...base, carat_min: ct, carat_max: +(ct * 1.1).toFixed(2), color_max: 'DEFGHIJKLMNOPQRSTUVWXYZ'[ci - 1], clarity_max: s.clarity }]);
    if (li > 0) asks.push(['Better clarity', { ...base, carat_min: ct, carat_max: +(ct * 1.1).toFixed(2), color_max: s.color, clarity_max: CLARITY_API[li - 1] }]);
    if (ct < 9) asks.push(['Larger carat', { ...base, carat_min: +(ct * 1.1).toFixed(2), carat_max: +(ct * 1.4).toFixed(2), color_max: s.color, clarity_max: s.clarity }]);
    const found = await Promise.all(asks.map(async ([label, q]) => {
      try { const j = await (await fetch(`${API}/api/search?${new URLSearchParams(q)}`)).json(); return [label, j.items]; } catch (e) { return [label, []]; }
    }));
    // each suggestion a different diamond (a D VVS2 can be the cheapest "better color" and "better clarity" at once)
    const used = new Set([s.id]), items = [], pools = {};
    for (const [label, list] of found) {
      // diamonds r5 (2026-10-23): only photographed stones are suggested (the outline-only tile looked unfinished);
      // r6: the rest of each kind's photographed stones wait as replacements
      pools[label] = (list || []).filter((x) => !noPhoto(x));
      const d = pools[label].find((x) => !used.has(x.id));
      if (d) { used.add(d.id); items.push([label, d]); }
    }
    if (!items.length) return;
    const list = pageEl.querySelector('[data-similar-list]');
    list.__mgSim = { s, pools, used };
    list.innerHTML = items.map(([label, d]) => simCard(label, d, s)).join('');
    // refine r4: one or two suggestions sit centred instead of at the left of a three-column row
    list.classList.toggle('is-few', items.length < 3);
    list.style.setProperty('--mgd-n', items.length);
    wireImages(list);
    pageEl.querySelector('[data-similar]').hidden = false;
  }

  // Owner, 2026-10-16 (Brilliant Earth's diamond page as the reference): on computers the photo and the 360° sit side
  // by side; under them, tabs (owner: "tabs below those two main images that people can click through instead of
  // scrolling down") switch the report, dimensions and proportions in one box of the report's own 1008 x 612 shape,
  // so the tabs and everything below them never move. The 360° tile shows the photo with a play button until it is
  // pressed (the viewers are heavy); the report is drawn when it comes near the screen.
  const WIDE = window.matchMedia('(min-width: 990px)');
  function tiles(s) {
    const box = pageEl.querySelector('[data-tiles]');
    const v = views(s);
    const top = v.filter((x) => x.key === 'photo' || x.key === 'video'), rest = v.filter((x) => !top.includes(x));
    box.innerHTML = `<div class="mgd-p__duo${top.length === 1 ? ' is-one' : ''}">${top.map((x) => `<figure class="mgd-p__tile mgd-p__tile--${x.key}" data-tile="${x.key}">
        <div class="mgd-d__stage mgd-d__stage--${x.key}" data-tile-stage></div>${x.key === 'video' ? `<figcaption class="mgd-p__tile-cap">${x.label}</figcaption>` : ''}</figure>`).join('')}</div>
      ${rest.length ? `<div class="mgd-p__tabs" role="tablist" aria-label="More views of this diamond">${rest.map((x, i) => `<button type="button" role="tab" class="mgd-p__tab" id="MgdTab-${x.key}" data-tab="${x.key}" aria-controls="MgdPanel" aria-selected="${i === 0}" tabindex="${i === 0 ? 0 : -1}">${x.label}</button>`).join('')}</div>
      <div class="mgd-p__panel" id="MgdPanel" role="tabpanel" aria-labelledby="MgdTab-${rest[0].key}"><div class="mgd-d__stage" data-panel-stage></div></div>` : ''}`;
    box.querySelectorAll('[data-tile]').forEach((t) => {
      const key = t.dataset.tile, st = t.querySelector('[data-tile-stage]');
      if (key === 'video' && s.img) {
        st.innerHTML = `${viewHtml(s, 'photo')}<button type="button" class="mgd-p__play" aria-label="Play the 360° video"><svg viewBox="0 0 40 40" aria-hidden="true"><path d="M16 12.5l12 7.5-12 7.5z" fill="currentColor"/></svg></button>`;
        st.querySelector('.mgd-p__play').addEventListener('click', () => { st.classList.remove('is-loaded'); t.classList.add('is-playing'); st.innerHTML = viewHtml(s, 'video'); centreVideo(st, s); }, { once: true });
      } else st.innerHTML = viewHtml(s, key);
    });
    wireImages(box);
    const tabs = [...box.querySelectorAll('[data-tab]')];
    if (!tabs.length) return;
    const panel = box.querySelector('[data-panel-stage]').parentElement, st = panel.firstElementChild;
    let io = null;
    const pick = (key) => {
      tabs.forEach((t) => { const on = t.dataset.tab === key; t.setAttribute('aria-selected', String(on)); t.tabIndex = on ? 0 : -1; });
      panel.setAttribute('aria-labelledby', `MgdTab-${key}`);
      if (io) { io.disconnect(); io = null; }
      st.className = `mgd-d__stage mgd-d__stage--${key}`;
      st.innerHTML = viewHtml(s, key, true);
      if (key === 'dimensions') placeDimensions(st, s);
      if (key === 'report') {
        if ('IntersectionObserver' in window) {
          io = new IntersectionObserver(([en]) => { if (en.isIntersecting) { io.disconnect(); io = null; drawReport(st, s); } }, { rootMargin: '300px' });
          io.observe(st);
        } else drawReport(st, s);
      }
    };
    tabs.forEach((t) => t.addEventListener('click', () => pick(t.dataset.tab)));
    // arrow keys move along the tabs, as tab lists do
    box.querySelector('[role=tablist]').addEventListener('keydown', (e) => {
      const i = tabs.indexOf(document.activeElement); if (i < 0) return;
      const j = { ArrowRight: i + 1, ArrowLeft: i - 1, Home: 0, End: tabs.length - 1 }[e.key];
      if (j === undefined) return;
      e.preventDefault();
      const t = tabs[(j + tabs.length) % tabs.length]; t.focus(); pick(t.dataset.tab);
    });
    pick(tabs[0].dataset.tab);
  }

  // ---------- magnifier (owner, 2026-10-17: "when i click on the products ... a magnifying glass to show and ... a small
  // window to pop out") ----------
  // The diamond page photo shows a magnifying-glass cursor and badge; a click opens a small window (the supplier photos
  // are ~600-750 px, so no full screen) where a round glass follows the pointer or finger at 2.5x.
  const ZOOM = 2.5;
  let zoomDlg = null;
  function zoomDialog() {
    if (zoomDlg) return zoomDlg;
    document.body.insertAdjacentHTML('beforeend', `<dialog class="mgd-zoom" aria-labelledby="MgdZoomTitle">
      <div class="mgd-zoom__box">
        <div class="mgd-zoom__head"><p class="mgd-zoom__title" id="MgdZoomTitle"></p>
          <button type="button" class="mgd-zoom__close" aria-label="Close" data-zoom-close><svg viewBox="0 0 20 20" aria-hidden="true"><path d="M4 4l12 12M16 4L4 16" stroke="currentColor" stroke-width="1.4" fill="none"/></svg></button></div>
        <div class="mgd-zoom__stage" data-zoom-stage><img alt=""><span class="mgd-zoom__lens" aria-hidden="true"><span class="mgd-zoom__inner"><img alt=""></span></span></div>
        <p class="mgd-zoom__hint">${matchMedia('(hover: hover)').matches ? 'Move over the diamond to magnify' : 'Touch and drag to magnify'}</p>
      </div></dialog>`);
    const d = document.body.lastElementChild, stage = d.querySelector('[data-zoom-stage]'), lens = d.querySelector('.mgd-zoom__lens'), inner = lens.firstElementChild;
    const move = (e) => {
      const r = stage.getBoundingClientRect(), x = Math.max(0, Math.min(r.width, e.clientX - r.left)), y = Math.max(0, Math.min(r.height, e.clientY - r.top));
      const D = lens.offsetWidth;
      inner.style.width = `${r.width}px`; inner.style.height = `${r.height}px`;
      lens.style.transform = `translate(${x - D / 2}px, ${y - D / 2}px)`;
      inner.style.transform = `translate(${D / 2 - x * ZOOM}px, ${D / 2 - y * ZOOM}px) scale(${ZOOM})`;
      lens.classList.add('is-on');
    };
    stage.addEventListener('pointerdown', (e) => { move(e); if (e.pointerType !== 'mouse') stage.setPointerCapture(e.pointerId); });
    stage.addEventListener('pointermove', (e) => { if (e.pointerType === 'mouse' || e.buttons) move(e); });
    stage.addEventListener('pointerleave', () => lens.classList.remove('is-on'));
    stage.addEventListener('pointerup', (e) => { if (e.pointerType !== 'mouse') lens.classList.remove('is-on'); });
    d.addEventListener('click', (e) => { if (e.target === d || e.target.closest('[data-zoom-close]')) d.close(); });
    d.addEventListener('close', () => { document.documentElement.classList.remove('mgd-zoom-open'); lens.classList.remove('is-on'); });
    return (zoomDlg = d);
  }
  function openZoom(img) {
    const d = zoomDialog();
    d.querySelector('.mgd-zoom__title').textContent = (pageEl.querySelector('.mgd-p__title') || {}).textContent || '';
    d.querySelectorAll('[data-zoom-stage] img').forEach((z) => {
      z.crossOrigin = 'anonymous'; z.referrerPolicy = 'no-referrer'; z.src = img.currentSrc || img.src; // dia r8: the same CORS copy
      ['--mgd-k', '--mgd-x', '--mgd-y'].forEach((k) => z.style.setProperty(k, img.style.getPropertyValue(k)));
      z.classList.toggle('is-open', img.classList.contains('is-open'));
      z.parentElement.style.setProperty('--mgd-ground', img.parentElement.style.getPropertyValue('--mgd-ground'));
    });
    document.documentElement.classList.add('mgd-zoom-open');
    d.showModal();
  }
  pageEl.addEventListener('click', (e) => {
    const st = e.target.closest('.mgd-d__stage--photo');
    const img = st && st.closest('[data-mgd-page]') && st.querySelector('img');
    if (img && img.complete && img.naturalWidth) openZoom(img);
  });

  function wireStone(s) {
    const stage = pageEl.querySelector('[data-stage]');
    const pill = pageEl.querySelector('[data-pill]');
    const thumbs = [...pageEl.querySelectorAll('[data-view]')];
    const show = (key) => {
      thumbs.forEach((x) => x.setAttribute('aria-pressed', String(x.dataset.view === key)));
      if (pill) pill.hidden = key !== 'photo';
      stage.className = 'mgd-d__stage mgd-d__stage--' + key;
      stage.parentElement.classList.toggle('is-wide', key === 'report'); // the certificate is landscape: full column width
      stage.innerHTML = viewHtml(s, key);
      if (key === 'video') centreVideo(stage, s);
      if (key === 'photo') wireImages(pageEl);
      if (key === 'dimensions') placeDimensions(stage, s);
      if (key === 'report') drawReport(stage, s);
    };
    thumbs.forEach((b) => b.addEventListener('click', () => show(b.dataset.view)));
    if (pill) pill.addEventListener('click', () => show('video'));
    const tilesBox = pageEl.querySelector('[data-tiles]');
    let mode = null;
    const gallery = () => {
      if (mode === WIDE.matches) return;
      mode = WIDE.matches;
      if (WIDE.matches) { stage.innerHTML = ''; tiles(s); } // computers: the grid
      else { tilesBox.innerHTML = ''; show(thumbs[0] ? thumbs[0].dataset.view : 'photo'); } // photo first, else the 360° video
    };
    gallery();
    WIDE.addEventListener('change', gallery);
    // computers: the details column stays in view beside the grid while it fits the window
    const info = pageEl.querySelector('.mgd-p__info');
    const hold = () => info.classList.toggle('is-held', WIDE.matches && info.offsetHeight + 180 < window.innerHeight);
    hold();
    window.addEventListener('resize', hold);
    pageEl.querySelectorAll('.mgd-p__specs').forEach((d) => d.addEventListener('toggle', hold));
    const add = pageEl.querySelector('[data-add]');
    const msg = pageEl.querySelector('[data-msg]');
    // owner, 2026-10-16 ("keep the scrolling thing ... like the engagement ring section"): the ring pages' bottom bar, on
    // every screen, once the shopper has scrolled past the main Add to bag (not while it is still below the fold)
    const bar = pageEl.querySelector('[data-sticky]');
    pageEl.querySelector('[data-sticky-add]').addEventListener('click', () => { add.scrollIntoView({ block: 'center', behavior: 'smooth' }); add.click(); });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(([en]) => {
        // phone r1 (2026-10-22): on phones the bar shows whenever the button is off screen, from load (as the ring pages)
        const show = !en.isIntersecting && (en.boundingClientRect.top < 0 || window.matchMedia('(max-width: 749px)').matches);
        bar.classList.toggle('is-on', show); bar.setAttribute('aria-hidden', String(!show));
        document.documentElement.classList.toggle('mgd-sticky-on', show);
      }).observe(add);
    }
    add.addEventListener('click', async () => {
      add.classList.add('loading'); add.setAttribute('aria-disabled', 'true'); msg.textContent = '';
      try {
        const r = await fetch(`${API}/api/select`, { method: 'POST', headers: { 'Content-Type': 'application/json', ...(dayOn() ? { 'X-MG-Daytime': '1' } : {}) }, body: JSON.stringify({ id: s.id }) });
        const j = await r.json().catch(() => ({}));
        if (!r.ok || !j.variantId) throw new Error(j.error || r.status);
        await addToBag(j.variantId, add);
      } catch (e) {
        msg.innerHTML = ['not_found', 'sold'].includes(String(e.message))
          ? 'This diamond was just sold. Please choose another, or <a href="' + esc(root.dataset.appointment) + '">book an appointment</a>.'
          : 'We couldn’t add this diamond right now. <a href="' + esc(root.dataset.appointment) + '">Book an appointment</a> and we’ll reserve it for you.';
      } finally {
        add.classList.remove('loading'); add.removeAttribute('aria-disabled');
      }
    });
  }

  async function addToBag(variantId, btn) {
    const drawer = document.querySelector('cart-drawer');
    const fd = new FormData();
    fd.append('id', variantId); fd.append('quantity', 1);
    if (root.dataset.returns) fd.append('properties[Returns]', 'Final sale'); // owner, 2026-10-16: loose diamonds are final sale
    if (drawer && drawer.getSectionsToRender) {
      fd.append('sections', drawer.getSectionsToRender().map((x) => x.id));
      fd.append('sections_url', location.pathname);
    }
    const r = await fetch(root.dataset.cartAddUrl || '/cart/add', { method: 'POST', headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' }, body: fd });
    const res = await r.json();
    if (res.status) throw new Error(res.description || 'cart');
    if (!drawer || !drawer.renderContents) { location.href = root.dataset.cartUrl || '/cart'; return; }
    if (window.publish && window.PUB_SUB_EVENTS) window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'mg-diamond-search', productVariantId: variantId });
    drawer.setActiveElement && drawer.setActiveElement(btn);
    drawer.renderContents(res);
    // review r1: as the theme's product form does, or a bag that was empty keeps hiding its subtotal and Checkout
    drawer.classList.remove('is-empty');
  }

  window.addEventListener('popstate', () => {
    if (root.classList.contains('is-detail')) return;
    const before = JSON.stringify(state); readUrl();
    if (JSON.stringify(state) !== before) { loadControls(); search(false); }
  });

  // ---------- back to the same place (review r1, owner: "no friction when roaming") ----------
  // Leaving the search saves how many pages were open and where the shopper was (the diamond they opened, or the first
  // card in view). Coming back with the browser's Back button, a reload, or the diamond page's "Diamonds" link reopens
  // those pages and puts that card back where it was on the screen.
  const POS = 'mgd:pos';
  let opened = '';
  const anchorCard = () => (opened && grid.querySelector(`a[data-id="${CSS.escape(opened)}"]`))
    || [...grid.querySelectorAll('a[data-id]')].find((a) => a.getBoundingClientRect().bottom > $('.mgd-bar').getBoundingClientRect().bottom);
  function savePos() {
    if (root.classList.contains('is-detail')) return;
    const a = anchorCard();
    try {
      sessionStorage.setItem(POS, JSON.stringify({ url: location.pathname + location.search, pages: page, y: Math.round(scrollY),
        id: a ? a.dataset.id : '', top: a ? Math.round(a.getBoundingClientRect().top) : 0 }));
    } catch (e) { /* private mode */ }
  }
  pageEl.addEventListener('click', (e) => { if (e.target.closest('[data-mgd-back]')) { try { sessionStorage.setItem('mgd:return', '1'); } catch (x) { /* private mode */ } } });

  // ---------- start ----------
  const stoneId = new URLSearchParams(location.search).get('stone');
  if (stoneId) { showStone(stoneId.toUpperCase()); return; }
  $$('[data-range]').forEach(buildRange);
  readUrl();
  remember();
  let back = null;
  try {
    const nav = (performance.getEntriesByType && performance.getEntriesByType('navigation')[0]) || {};
    const saved = JSON.parse(sessionStorage.getItem(POS) || 'null');
    const asked = sessionStorage.getItem('mgd:return') === '1';
    sessionStorage.removeItem('mgd:return');
    if (saved && saved.url === location.pathname + location.search && (asked || nav.type === 'back_forward' || nav.type === 'reload')) back = saved;
  } catch (e) { /* private mode: start at the top */ }
  if ('scrollRestoration' in history) history.scrollRestoration = 'manual';
  grid.addEventListener('click', (e) => { const a = e.target.closest('a[data-id]'); if (a) { opened = a.dataset.id; savePos(); } });
  window.addEventListener('pagehide', savePos);
  (async () => {
    // dia r8 (2026-10-25): the search no longer waits for /api/meta (the price slider's range and the daytime window);
    // both answers may already be on their way (the section asks as the page arrives)
    const early = window.__mgdEarly || {};
    const metaP = API ? (early.meta || fetch(`${API}/api/meta`)).then((r) => r.json()).catch(() => null) : Promise.resolve(null);
    early.meta = null;
    onDaySwitch = () => search(false, page); // the same pages, new prices
    const first = search(false, back ? Math.min(20, Math.max(1, back.pages | 0)) : 1);
    const m = await metaP;
    if (m) {
      const g = Object.values(m.groups || {});
      if (g.length) PRICE = [Math.max(1, Math.min(...g.map((x) => x.price[0]))), Math.max(...g.map((x) => x.price[1]))];
      setDay(m.daytime);
      if (dayOn() && m.daytime && m.daytime.ratio) { const [dy, mk] = m.daytime.ratio; PRICE = PRICE.map((p) => Math.max(1, Math.floor((2 * p * dy + mk) / (2 * mk)))); }
    }
    loadControls();
    await first;
    // a price filter reads the daytime prices while that window is open: ask again now that the window is known
    if (dayOn() && (state.price_min || state.price_max)) await search(false, page);
    if (back) {
      const a = back.id && grid.querySelector(`a[data-id="${CSS.escape(back.id)}"]`);
      window.scrollTo({ top: a ? a.getBoundingClientRect().top + scrollY - back.top : back.y, behavior: 'instant' });
    }
  })();
})();
